import { render, staticRenderFns } from "./lightRailTraffic.vue?vue&type=template&id=19a50142&scoped=true&"
import script from "./lightRailTraffic.vue?vue&type=script&lang=js&"
export * from "./lightRailTraffic.vue?vue&type=script&lang=js&"
import style0 from "./lightRailTraffic.vue?vue&type=style&index=0&id=19a50142&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a50142",
  null
  
)

export default component.exports